import { createAsyncThunk } from "@reduxjs/toolkit";
import { getContactUs, getTableColumnNames, getUserWithTotalPayment } from "../../helpers/fakebackend_helper";


// Fetch Chat Report Table Column Names 
export const fetchcontactSupportTableColumnNames = createAsyncThunk(
  "contactSupport/fetchcontactSupportTableColumnNames",
  async (contactSupport, thunkAPI) => {
    try {
      const response = await getTableColumnNames(contactSupport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);


// Fetch Contact Support list
export const fetchContactSupportList = createAsyncThunk(
  "contactSupport/fetchContactSupportList",
  async (contactSupport, thunkAPI) => {
    try {
      const response = await getContactUs(contactSupport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Error fetching contact support list");
    }
  }
);